import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Waypoint from 'react-waypoint';

import { sortsymbols } from '../../../service/stocks'; // @TODO rename

import LoadingComponent from '../../LoadingComponent';
import FeedRow from '../../../containers/table/feed/FeedRow';
import FundRow from '../../../components/table/feed/FundRow';
import FlexTable from '../FlexTable';

import table from '../../../styles/table/flextable';
import css from '../../../styles/table/feedtable';

export default class FeedTable extends Component {
    static propTypes = {
        // Props
        symbols: PropTypes.array.isRequired,
        filters: PropTypes.object.isRequired,
        changeFilters: PropTypes.func.isRequired,
        isFetching: PropTypes.bool.isRequired,
        loading: PropTypes.func,
        className: PropTypes.string,
        funds: PropTypes.bool,

        // State to props
        breakpoint: PropTypes.string,
    };

    constructor(props) {
        super(props);

        this.state = { rowLimit: 50 };
        this._rowLimitIncrement = 50;
        this._defaultDirection = 'DESC';

        // Get appropriate column name based on period
        this._getColumn = (period, column) => {
            if ((column.indexOf('CHANGE') < 0 && column.indexOf('RET') < 0) || period === 'DAY') {
                return column;
            }

            const change = [];
            if (this.props.funds) {
                change.push('RET');
            } else {
                change.push('CHANGE_');
            }

            change.push(period);
            if (column === 'CHANGE_PCT') {
                change.push('_PCT');
            }

            return change.join('');
        };

        this.onSortClick = (column) => {
            const { sort } = this.props.filters;
            // If same column, alternate direction
            if (sort.column === column) {
                const otherDirection = sort.direction === 'ASC' ? 'DESC' : 'ASC';

                this.props.changeFilters({
                    sort: { column, direction: otherDirection },
                });

                return;
            }

            // If different column, use default direction
            this.props.changeFilters({
                sort: { column, direction: this._defaultDirection },
            });
        };

        this._onWaypointEnter = () => {
            let newLimit = this.state.rowLimit + this._rowLimitIncrement;
            if (newLimit > this.props.symbols.length) {
                newLimit = this.props.symbols.length;
            }
            this.setState({ rowLimit: newLimit });
        };
    }

    componentDidMount() {
        if (this.props.loading) {
            this.props.loading();
        }
    }

    renderFunds(symbols, classNames) {
        const tableColumns = [
            'SECURITYNAME',
            'PRICE',
            'PRICECHANGEPCT',
        ];

        return (
            <FlexTable
                columns={tableColumns}
                className={classNames}
                onSortClick={this.onSortClick}
                filters={this.props.filters}
            >
                {symbols.map(({ values }) => (
                  <FundRow
                      key={[values.ITEM, values.SECTOR].join('.')}
                      period={this.props.filters.period}
                      {...values}
                  />
                ))}
            </FlexTable>
        );
    }

    renderDefault(symbols, classNames) {
        const tableColumns = [
            'LONG_NAME',
            'LAST',
            'CHANGE_PCT',
        ];

        return (
            <FlexTable
                columns={tableColumns}
                className={classNames}
                onSortClick={this.onSortClick}
                filters={this.props.filters}
            >
                {symbols.map(({ values }) => (
                  <FeedRow
                      key={[values.ITEM, values.SECTOR].join('.')}
                      period={this.props.filters.period}
                      {...values}
                  />
                ))}
            </FlexTable>
        );
    }

    render() {
        const { symbols, isFetching, filters: { sort, period } } = this.props;

        if (isFetching) {
            return (<LoadingComponent height={400} />);
        }

        const classNames = [table.padded];
        if (this.props.className) {
            classNames.push(this.props.className);
        }

        const sortedSymbols = sortsymbols(
            symbols,
            this._getColumn(period, sort.column),
            sort.direction
        );

        // Limit amount of rows, increases on waypoint enter
        const limitedSymbols = sortedSymbols.slice(0, this.state.rowLimit);

        // @TODO Do this differently? Currently checks if table is for funds
        return (
            <div className={css.feedContainer}>
                {this.props.funds
                    ? this.renderFunds(limitedSymbols, classNames)
                    : this.renderDefault(limitedSymbols, classNames)}

                {this.state.rowLimit < this.props.symbols.length ? (
                    <div>
                        <div className={css.waypointContainer}>
                            <Waypoint onEnter={this._onWaypointEnter} />
                        </div>
                        <LoadingComponent height={40} />
                    </div>
                ) : ''}
            </div>
        );
    }
}



/** WEBPACK FOOTER **
 ** /src/shared/components/table/feed/FeedTable.js
 **/